export default __webpack_public_path__ + "media/images/plot-5-hr-704433e98f2e6b731644c3eb279c7561.png";